export interface VoiceOption {
  id: string;
  label: string;
  lang: "en-us" | "en-gb";
  gender: "female" | "male";
}

export const VOICES: VoiceOption[] = [
  // American English — Female
  { id: "af_alloy", label: "Alloy", lang: "en-us", gender: "female" },
  { id: "af_aoede", label: "Aoede", lang: "en-us", gender: "female" },
  { id: "af_bella", label: "Bella", lang: "en-us", gender: "female" },
  { id: "af_heart", label: "Heart", lang: "en-us", gender: "female" },
  { id: "af_jessica", label: "Jessica", lang: "en-us", gender: "female" },
  { id: "af_kore", label: "Kore", lang: "en-us", gender: "female" },
  { id: "af_nicole", label: "Nicole", lang: "en-us", gender: "female" },
  { id: "af_nova", label: "Nova", lang: "en-us", gender: "female" },
  { id: "af_river", label: "River", lang: "en-us", gender: "female" },
  { id: "af_sarah", label: "Sarah", lang: "en-us", gender: "female" },
  { id: "af_sky", label: "Sky", lang: "en-us", gender: "female" },
  // American English — Male
  { id: "am_adam", label: "Adam", lang: "en-us", gender: "male" },
  { id: "am_echo", label: "Echo", lang: "en-us", gender: "male" },
  { id: "am_eric", label: "Eric", lang: "en-us", gender: "male" },
  { id: "am_fenrir", label: "Fenrir", lang: "en-us", gender: "male" },
  { id: "am_liam", label: "Liam", lang: "en-us", gender: "male" },
  { id: "am_michael", label: "Michael", lang: "en-us", gender: "male" },
  { id: "am_onyx", label: "Onyx", lang: "en-us", gender: "male" },
  { id: "am_puck", label: "Puck", lang: "en-us", gender: "male" },
  { id: "am_santa", label: "Santa", lang: "en-us", gender: "male" },
  // British English — Female
  { id: "bf_alice", label: "Alice", lang: "en-gb", gender: "female" },
  { id: "bf_emma", label: "Emma", lang: "en-gb", gender: "female" },
  { id: "bf_isabella", label: "Isabella", lang: "en-gb", gender: "female" },
  { id: "bf_lily", label: "Lily", lang: "en-gb", gender: "female" },
  // British English — Male
  { id: "bm_daniel", label: "Daniel", lang: "en-gb", gender: "male" },
  { id: "bm_fable", label: "Fable", lang: "en-gb", gender: "male" },
  { id: "bm_george", label: "George", lang: "en-gb", gender: "male" },
  { id: "bm_lewis", label: "Lewis", lang: "en-gb", gender: "male" },
];

export const DEFAULT_VOICE_ID = "am_onyx";

export const VOICE_GROUPS: { label: string; voices: VoiceOption[] }[] = [
  { label: "US Female", voices: VOICES.filter(v => v.lang === "en-us" && v.gender === "female") },
  { label: "US Male",   voices: VOICES.filter(v => v.lang === "en-us" && v.gender === "male") },
  { label: "UK Female", voices: VOICES.filter(v => v.lang === "en-gb" && v.gender === "female") },
  { label: "UK Male",   voices: VOICES.filter(v => v.lang === "en-gb" && v.gender === "male") },
];
